import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "../../assets/css/Footer.css";
import { arrow2 } from "../../constant";
import {
  GetBrands,
  GetCampaign,
  GetProductDate,
  GetUrls,
  PostNewsLetter,
} from "../../network/Network";
import {
  AllBrands,
  AllDonationCampaign,
  AllURls,
} from "../../redux/actions/AuthActions";
import { AllDeliveryDates } from "../../redux/actions/CartActions";

function Footer() {
  const dispatch = useDispatch();
  const [newsEmail, setNewsEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const siteSettings = useSelector((state) => state?.AuthReducer?.siteSettings);

  // Get Pages Data
  useEffect(() => {
    GetUrls()
      .then((res) => {
        dispatch(AllURls(res?.data?.base_urls));
      })
      .catch((err) => {});
  }, []);

  const SubmitNewsLetter = (e) => {
    setLoading(true);
    e.preventDefault();
    if (!newsEmail) {
      toast.error("Please Enter Email Address");
      setLoading(false);
      return;
    }
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        newsEmail
      )
    ) {
      toast.error("Invalid Email");
      setLoading(false);
      return;
    }
    let data = {
      email: newsEmail,
    };
    PostNewsLetter(data)
      .then((res) => {
        toast.success(res?.data?.message);
        setLoading(false);
        setNewsEmail("");
      })
      .catch((err) => {
        if (err?.response?.data?.errors[0]?.code == "email") {
          toast.error(err?.response?.data?.errors[0]?.message);
          setLoading(false);
          return;
        }
        if (err?.response?.data?.errors?.email) {
          toast.error(err?.response?.data?.errors?.email[0]);
          setLoading(false);
          return;
        }
        setLoading(false);
      });
  };

  // Get delivery date
  useEffect(() => {
    GetProductDate()
      .then((res) => {
        dispatch(AllDeliveryDates(res?.data));
      })
      .catch((err) => {});
  }, []);

  // Get camping Data
  useEffect(() => {
    GetCampaign()
      .then((res) => {
        dispatch(AllDonationCampaign(res?.data));
      })
      .catch((err) => {});
  }, []);

  return (
    <section className="Footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 ">
            <h2 className="main-title">Newsletter</h2>
            <div>
              <input
                value={newsEmail}
                onChange={(e) => setNewsEmail(e.target.value)}
                type="text"
                placeholder="Write Your Email"
              />
            </div>
            <div>
              <button
                onClick={(e) => SubmitNewsLetter(e)}
                disabled={loading}
                className="btn book-btn buttunset"
              >
                {/* SUBMIT */}
                {loading ? "Loading..." : "Submit"}
                <img
                  src={arrow2}
                  className="image-fluid arrow-img-home-new ml-2"
                  alt=""
                />{" "}
              </button>
            </div>
          </div>

          <div className="offset-lg-1 col-lg-8">
            <div className="row">
              <div className="col-lg-3 ">
                <h2 className="main-title">Quick Links</h2>
                <div>
                  <Link to="/contact">Contact Us</Link>
                </div>
                <div>
                  <Link to="/about-us"> About Us</Link>
                </div>
                <div>
                  <Link to="/blogs">Blogs</Link>
                </div>
                <div>
                  <Link to="/faqs">FAQ's</Link>
                </div>
              </div>
              <div className="col-lg-3">
                <h2 className="main-title margin_footer">Extras</h2>

                <div>
                  <Link to="/testimonial">Testimonials</Link>
                </div>
                <div>
                  <Link to="/terms-conditions">Terms & Condition</Link>
                </div>
                <div>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                <div>
                  <Link to="/cancelation">Cancel Policy</Link>
                </div>
              </div>
              <div className="offset-lg-1 col-lg-5">
                <h2 className="main-title margin_footer">COMPANY INFO</h2>
                <div>
                  <p className="footer_p">
                    Email : {siteSettings?.hoho_company_email}
                  </p>
                </div>
                <div>
                  <p className="footer_p">
                    Contact : {siteSettings?.hoho_company_phone}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div>
              <h2 className="big-title">{siteSettings?.hoho_company_name}</h2>
            </div>
            <div>
              <p className="copy-right">
                Copyrights{" "}{siteSettings?.hoho_company_copyright_text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
